<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <h3> Input </h3>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Payload: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.input_location"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <h3> Output </h3>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="display: inline-block; width: 100%">
                        <v-select
                          v-model="stage.entity_type_id"
                          :items="available_types"
                          label="Tipo de salida"
                          item-text="name"
                          item-value="uuid"
                          outlined
                          hide-details="auto"
                        />
                      </div>
                    </template>
                    <span style="max-width: 350px; white-space: normal; display: block;" v-if="stage.entity_type_id">
                        {{available_types.find(t => t.uuid === stage.entity_type_id).schema}}
                      </span>
                </v-tooltip>

                    
            </v-col>
            <v-col cols="6">
                <v-text-field
                    v-model="stage.save_as_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <WackScriptEditor
                    v-model="stage.script"
                    @input="computeStage">
                </WackScriptEditor>
            </v-col>
        </v-row>
        
        
    </div>
</template>

<script>
import { RunScript } from '@/modules/document/domain/WorkflowTemplate';
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
import WackScriptEditor from '@/modules/document/infra/WackScriptEditor';

export default {
    name:'RunScriptDetailComponent',
    components: {
        RouteInBagSelectorComponent,
        WackScriptEditor
    },
    props:{
        stage: {
            type: RunScript,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
            show_custom_prompt: false
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{
        
    },
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>